module.exports = __webpack_public_path__ + "static/media/saundarya.2ec4fe70.png";